import { ColDef } from "ag-grid-community";
import {
  idColumn,
  actionColumn,
  statusColumn,
  questionColumn,
} from "../../../../../utils/commonColumns";
import { generateColumn, renderNA } from "../../../../../utils/commonFunctions";

const answerOptionsColumn: ColDef = {
  ...generateColumn("Answer Options"),
};

const orderColumn: ColDef = {
  field: "order",
  headerName: "Order",
  filter: "agNumberColumnFilter",
};

const columnDefs: ColDef[] = [
  idColumn,
  questionColumn,
  answerOptionsColumn,
  {
    ...generateColumn("", `industries`),
   
    cellRenderer: (props: any) => {
      return renderNA(props.data?.[`industries`]?.map((data:any)=>{return data?.industry_name})?.toString());
    },
    filterValueGetter:(props: any) => {
      return renderNA(props.data?.[`industries`]?.map((data:any)=>{return data?.industry_name})?.toString());
    },
    tooltipValueGetter:(props: any) => {
      return renderNA(props.data?.[`industries`]?.map((data:any)=>{return data?.industry_name})?.toString());
    },
    valueGetter:(props: any) => {
      return props.data?.[`industries`]?.map((data:any)=>{return data?.industry_name})?.join("#");
    },
  },
  {
    ...generateColumn("", "description"),
    tooltipValueGetter: (props: any) => {
      return renderNA(props?.data?.["description"]);
    },
    filterValueGetter: (props: any) => {
      return renderNA(props?.data?.["description"]);
    },
    valueGetter: (props: any) => {
      return props?.data?.["description"];
    },
  },
  
  {
    ...generateColumn("Skill Categories", `skill_categorys`),

   
    cellRenderer: (props: any) => {
      return renderNA(props.data?.[`skill_categorys`]?.map((data:any)=>{return data?.name})?.toString());
    },
    filterValueGetter:(props: any) => {
      return renderNA(props.data?.[`skill_categorys`]?.map((data:any)=>{return data?.name})?.toString());
    },
    tooltipValueGetter:(props: any) => {
      return renderNA(props.data?.[`skill_categorys`]?.map((data:any)=>{return data?.name})?.toString());
    },
    valueGetter:(props: any) => {
      return props.data?.[`skill_categorys`]?.map((data:any)=>{return data?.name})?.join("#");
    },
  },
  {
    ...generateColumn("", `careers`),
   
    cellRenderer: (props: any) => {
      return renderNA(props.data?.[`careers`]?.map((data:any)=>{return data?.name})?.toString());
    },
    filterValueGetter:(props: any) => {
      return renderNA(props.data?.[`careers`]?.map((data:any)=>{return data?.name})?.toString());
    },
    tooltipValueGetter:(props: any) => {
      return renderNA(props.data?.[`careers`]?.map((data:any)=>{return data?.name})?.toString());
    },
    valueGetter:(props: any) => {
      return props.data?.[`careers`]?.map((data:any)=>{return data?.name})?.join("#");
    },
  },
  {
    ...generateColumn("Occupation Groups", `ocupationGroup`),
   
    cellRenderer: (props: any) => {
      return renderNA(props.data?.[`ocupationGroup`]?.map((data:any)=>{return data?.name})?.toString());
    },
    filterValueGetter:(props: any) => {
      return renderNA(props.data?.[`ocupationGroup`]?.map((data:any)=>{return data?.name})?.toString());
    },
    tooltipValueGetter:(props: any) => {
      return renderNA(props.data?.[`ocupationGroup`]?.map((data:any)=>{return data?.name})?.toString());
    },
    valueGetter:(props: any) => {
      return props.data?.[`ocupationGroup`]?.map((data:any)=>{return data?.name})?.join("#");
    },
  },
  orderColumn,
  statusColumn,
  actionColumn,
];
export default columnDefs;
